<template>
    <div class="container feedback template-bg-gray">
        <div class="row" >
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div v-bind:class="{'feedback-update-boxplr': !isBeforRequest && !isSubmitForm, 'thankupageplr88': !isBeforRequest && isSubmitForm }" class="card form-wrapper">
                        <div class="feedback_container feedback_newupdate">
                            <div class="row">
                              <div class="community-logo"  v-if="isShow">
                                <img :src="logoURL" class="top-logo custom-logo" :alt="community.content && community.content.parameter2 ? community.content.parameter2 : 'Community Logo'">
                              </div>
                              <CustomSkeleton :is-visible="!isShow" />
                            </div>
                            <template v-if="this.isBeforRequest && isShow" class="form-template" >
                              <h2 class=" template-title common-space-from-logo">What do you need help with?</h2>
                                <div v-if="community.content && community.content.requestIntroduction && !this.isSubmitForm">
                                    <p class=" box-sub-heading mb35 custom-content" v-html="community.content.requestIntroduction"></p>
                                </div>
                                <form @submit.prevent="save('form-request')"
                                    autocomplete="off"
                                    data-vv-scope="form-request" class="template-form">
                                    <div class="row">
                                      <div class="col-md-6 mb-17">
                                          <div class="input-group">
                                              <label class="template-label" for="firstName">{{configureFields.firstName.labelName}}</label><span class="required-symbol"> *</span>
                                              <input
                                                type="text"
                                                class="form-control input-value pt-input input-focus"
                                                ref="firstName"
                                                id="firstName"
                                                autocomplete="given-name"
                                                v-model="ask.first"
                                                name="first"
                                                placeholder=""
                                                v-validate="'required'"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.first') }"
                                                v-focus
                                                data-vv-validate-on="change"
                                              >
                                              <p
                                                class="error"
                                                v-show="errors.has('form-request.first')"
                                              >{{errors.first('form-request.first')}}</p>
                                          </div>
                                      </div>
                                      <div class="col-md-6 mb-17">
                                          <div class="input-group">
                                              <label class="template-label" for="lastName">{{configureFields.lastName.labelName}}</label><span class="required-symbol"> *</span>
                                              <input
                                                type="text"
                                                id="lastName"
                                                autocomplete="family-name"
                                                class="form-control input-value pt-input input-focus"
                                                v-model="ask.last"
                                                name="last"
                                                placeholder=""
                                                v-validate="'required'"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.last') }"
                                                data-vv-validate-on="change"
                                              >
                                              <p
                                                class="error"
                                                v-show="errors.has('form-request.last')"
                                              >{{errors.first('form-request.last')}}</p>
                                          </div>
                                      </div>
                                      <div class="col-md-6 mb-17">
                                          <div class="input-group">
                                              <label class="template-label" for="email">{{configureFields.emailAddress.labelName}}</label><span class="required-symbol"> *</span>
                                              <input
                                                type="email"
                                                class="form-control input-value pt-input input-focus"
                                                id="email"
                                                v-model="ask.email"
                                                name="email"
                                                placeholder=""
                                                autocomplete="email"
                                                @change="checkMemberStatus"
                                                v-validate.continues="'required|email'"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.email') }"
                                                data-vv-validate-on="change"
                                              >
                                              <p
                                                v-show="errors.has('form-request.email')"
                                                class="error"
                                              >{{ errors.first('form-request.email') }}</p>
                                          </div>
                                      </div>
                                      <div>
                                        <div class="col-md-6 mb-17"  v-if="configureFields.memberRole && configureFields.memberRole.include && configureFields.memberRole.include === true">
                                            <div class="input-group">
                                                <label class="template-label" for="memberRole">{{memberRole.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('memberRole')"> *</span>
                                                <select v-validate="`${checkAndValidate1('memberRole')}`"
                                                        class="form-control input-value template-drop-down pt-input input-focus select-dropdown requestPageDropdown"
                                                        v-model="dynamicFields.memberRole"
                                                        name="memberRole"
                                                        id="memberRole"
                                                        data-vv-validate-on="change|blur">

                                                    <option value="" selected disabled style="display:none">Select role</option>
                                                    <option v-for="role in memberRole.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
                                                </select>
                                                <p v-show="errors.has('form-request.memberRole')" class="error">{{ errors.first('form-request.memberRole') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-17" v-if="configureFields.adviceArea && configureFields.adviceArea.include && configureFields.adviceArea.include === true">
                                            <div class="input-group">
                                                <label class="template-label" for="adviceArea">{{adviceArea.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('adviceArea')"> *</span>
                                                <select v-validate="`${checkAndValidate1('adviceArea')}`"
                                                        class="form-control input-value template-drop-down pt-input input-focus select-dropdown requestPageDropdown"
                                                        v-model="dynamicFields.adviceArea"
                                                        name="adviceArea"
                                                        id="adviceArea"
                                                        data-vv-validate-on="change|blur">
                                                    <option value="" selected disabled style="display:none">Select Area</option>
                                                    <option v-for="role in adviceArea.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
                                                </select>
                                                <p v-show="errors.has('form-request.adviceArea')" class="error">{{ errors.first('form-request.adviceArea') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-17" v-if="configureFields.phoneNumber && configureFields.phoneNumber.include && configureFields.phoneNumber.include === true">
                                            <div class="input-group">
                                                <label class="template-label" for="phoneNumber">{{configureFields.phoneNumber.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('phoneNumber')"> *</span>
                                                <input
                                                type="text"
                                                class="form-control input-value pt-input input-focus"
                                                id="phoneNumber"
                                                v-model="dynamicFields.phoneNumber"
                                                name="phoneNumber"
                                                v-validate.continues="`${checkAndValidate1('phoneNumber')}`"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.phoneNumber') }"
                                                data-vv-validate-on="change"
                                                >
                                                <p
                                                v-show="errors.has('form-request.phoneNumber')"
                                                class="error"
                                                >{{ errors.first('form-request.phoneNumber') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mb-17" v-if="configureFields.linkedInProfile && configureFields.linkedInProfile.include && configureFields.linkedInProfile.include === true">
                                            <div class="input-group">
                                              <label class="template-label" for="linkedInProfile">{{configureFields.linkedInProfile.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('linkedInProfile')"> *</span>
                                              <input type="text"
                                                     class="form-control input-value pt-input input-focus"
                                                     v-model="dynamicFields.linkedInProfile"
                                                     id="linkedInProfile"
                                                     name="linkedInProfile"
                                                     v-bind:class="{'request-form-error-border': errors.has('form-request.linkedInProfile') }"
                                                     data-vv-validate-on="change"
                                                     v-validate="{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }">
                                              <p v-show="errors.has('form-request.linkedInProfile')" class="error">{{ errors.first('form-request.linkedInProfile') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-17" v-if="configureFields.college && configureFields.college.include && configureFields.college.include === true">
                                            <div class="input-group">
                                                <label class="template-label" for="college">{{configureFields.college.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('college')"> *</span>
                                                <input
                                                type="text"
                                                class="form-control input-value pt-input input-focus"
                                                id="college"
                                                v-model="dynamicFields.college"
                                                name="college"
                                                v-validate.continues="`${checkAndValidate1('college')}`"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.college') }"
                                                data-vv-validate-on="change"
                                                >
                                                <p
                                                v-show="errors.has('form-request.college')"
                                                class="error"
                                                >{{ errors.first('form-request.college') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-17" v-if="configureFields.classYear && configureFields.classYear.include && configureFields.classYear.include === true">
                                            <div class="input-group ">
                                                <label class="template-label" for="year">{{configureFields.classYear.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('year')"> *</span>
                                                <input
                                                type="text"
                                                class="form-control input-value pt-input input-focus"
                                                id="year"
                                                v-model="dynamicFields.year"
                                                name="year"
                                                v-validate.continues="`${checkAndValidate1('year')}`"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.year') }"
                                                data-vv-validate-on="change"
                                                >
                                                <p
                                                v-show="errors.has('form-request.year')"
                                                class="error"
                                                >{{ errors.first('form-request.year') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-17" v-if="configureFields.title && configureFields.title.include && configureFields.title.include === true">
                                              <div class="input-group">
                                                <label class="template-label" for="role">{{configureFields.title.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('role')"> *</span>
                                                <input
                                                type="text"
                                                class="form-control input-value pt-input input-focus"
                                                v-model="dynamicFields.role"
                                                id="role"
                                                name="role"
                                                v-validate.continues="`${checkAndValidate1('role')}`"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.role') }"
                                                data-vv-validate-on="change"
                                                >
                                                <p
                                                v-show="errors.has('form-request.role')"
                                                class="error"
                                                >{{ errors.first('form-request.role') }}</p>
                                              </div>
                                        </div>
                                        <div class="col-md-6 mb-17" v-if="configureFields.organization && configureFields.organization.include && configureFields.organization.include === true">
                                              <div class="input-group">
                                                  <label class="template-label" for="organization">{{configureFields.organization.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('organization')"> *</span>
                                                  <input
                                                  type="text"
                                                  class="form-control input-value pt-input input-focus"
                                                  id="organization"
                                                  v-model="dynamicFields.organization"
                                                  name="organization"
                                                  v-validate.continues="`${checkAndValidate1('organization')}`"
                                                  v-bind:class="{'request-form-error-border': errors.has('form-request.organization') }"
                                                  data-vv-validate-on="change"
                                                  >
                                                  <p
                                                  v-show="errors.has('form-request.organization')"
                                                  class="error"
                                                  >{{ errors.first('form-request.organization') }}</p>
                                              </div>
                                        </div>
                                        <div class="col-md-6 mb-17" v-if="configureFields.studentId && configureFields.studentId.include && configureFields.studentId.include === true">
                                              <div class="input-group">
                                                <label class="template-label" for="studentId">{{configureFields.studentId.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('studentId')"> *</span>
                                                <input
                                                type="text"
                                                class="form-control input-value pt-input input-focus"
                                                v-model="dynamicFields.studentId"
                                                id="studentId"
                                                name="studentId"
                                                v-validate.continues="`${checkAndValidate1('studentId')}`"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.studentId') }"
                                                data-vv-validate-on="change"
                                                >
                                                <p
                                                v-show="errors.has('form-request.studentId')"
                                                class="error"
                                                >{{ errors.first('form-request.studentId') }}</p>
                                              </div>
                                        </div>
                                        <div class="col-md-12 mb-17" v-if="configureFields.referrer && configureFields.referrer.include && configureFields.referrer.include === true">
                                          <div class="input-group">
                                            <label class="template-label" for="referrer">{{configureFields.referrer.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('referrer')"> *</span>
                                            <input
                                            type="text"
                                            id="referrer"
                                            class="form-control input-value pt-input input-focus"
                                            v-model="dynamicFields.referrer"
                                            name="referrer"
                                            v-validate.continues="`${checkAndValidate1('referrer')}`"
                                            v-bind:class="{'request-form-error-border': errors.has('form-request.referrer') }"
                                            data-vv-validate-on="change">
                                            <p v-show="errors.has('form-request.referrer')"
                                            class="error">{{ errors.first('form-request.referrer') }}</p>
                                          </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.referrer2 && configureFields.referrer2.include && configureFields.referrer2.include === true">
                                          <div class="input-group">
                                            <label class="template-label" for="referrer2">{{configureFields.referrer2.labelName}}<span class="required-symbol" v-if="checkAndValidate1('referrer2')"> *</span></label>
                                            <select id="referrer2"
                                            v-validate="`${checkAndValidate1('referrer2')}`"
                                            class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                            v-model="dynamicFields.referrer2"
                                            name="referrer2"
                                            data-vv-validate-on="change">
                                                <option value="" selected disabled style="display:none">Select</option>
                                                <option v-for="(degree, idx) in referrer2.memberValue" :key="`referrer-${idx}`" :value="degree.trim()">{{degree.trim()}}</option>
                                            </select>
                                            <p
                                            v-show="errors.has('step-1.referrer2')"
                                            class="error"
                                            >{{ errors.first('step-1.referrer2') }}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- <div class="col-md-6 mb-17">
                                      </div> -->
                                      <div class="col-md-12 mb-17">
                                          <div class="input-group">
                                              <label class="template-label" for="title">{{configureFields.subject.labelName}}</label><span class="required-symbol"> *</span>
                                              <input
                                                type="text"
                                                class="form-control input-value pt-input w-100 input-focus"
                                                id="title"
                                                :placeholder="this.requestForm.subjectLine"
                                                v-model="ask.subject"
                                                name="title"
                                                v-validate="'required'"
                                                v-bind:class="{'request-form-error-border': errors.has('form-request.title') }"
                                                data-vv-validate-on="change"
                                              >
                                              <p
                                                class="error"
                                                v-show="errors.has('form-request.title')"
                                              >{{errors.first('form-request.title')}}</p>
                                          </div>
                                      </div>
                                      <div class="col-md-12" v-if="configureFields.dueDate && configureFields.dueDate.include && configureFields.dueDate.include === true">
                                          <div class="input-group">
                                              <label class="template-label" for="dueDate">{{configureFields.dueDate.labelName}}</label><span class="required-symbol" v-if="checkAndValidate1('dueDate')"> *</span>
                                              <datepicker id="dueDate"
                                                          name="dueDate"
                                                          class="input-focus template-input-date-picker"
                                                          v-model="dynamicFields.dueDate"
                                                          v-bind:class="{'request-form-error-border': errors.has('form-request.dueDate') }" :format="DatePickerFormat" :disabledDates="disabledDates"
                                                          v-validate.continues="`${checkAndValidate1('dueDate')}`"
                                                          data-vv-validate-on="change|blur"></datepicker>
                                              <span class="helper-text template-label mb-0-custom"><strong>Note:</strong> Does your request have an expiration date after which an answer is no longer desirable?</span>
                                              <p
                                              v-show="errors.has('form-request.dueDate')"
                                              class="error"
                                              >{{ errors.first('form-request.dueDate') }}</p>
                                          </div>
                                      </div>
                                      <div class="col-md-12">
                                          <label class="template-label" for="message">{{configureFields.question.labelName}}</label><span class="required-symbol"> *</span>
                                          <div class="input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2">
                                              <textarea
                                                  class="form-control pt-input request-form-question-textarea"
                                                  id="message"
                                                  :placeholder="this.requestForm.question"
                                                  aria-label="Question"
                                                  v-model="ask.text"
                                                  name="message"
                                                  :maxlength="max"
                                                  v-validate.continues="'required|max:2000'"
                                                  v-on:keyup="countdown"
                                                  rows="21"
                                                  v-bind:class="{'request-form-error-border': errors.has('form-request.message') }"
                                                  data-vv-validate-on="change"
                                                ></textarea>
                                                <div class="form-group pd-remove unsubscribe-btn mb-0-custom">
                                              <div
                                                  aria-live="polite"
                                                  class="char-counter template-subject-counter"
                                                  v-bind:class="{'char-count-error': exceedsMaxCount }"
                                              >{{remainingCount}}  / 2000</div>
                                          </div>
                                          </div>
                                        <p id="question-field-error" class="error error-mb--2">
                                            <span
                                            v-for="(error,index) in errors.collect('form-request.message')"
                                            v-bind:key="index"
                                          >{{ error }}</span>
                                        </p>
                                      </div>
                                    </div>
                                    <div class="row mlr0" v-if="configureFields.disclaimer && configureFields.disclaimer.include && configureFields.disclaimer.include === true">
                                        <div class="form-group disclaimer">
                                            <md-checkbox  name="disclaimer"
                                                          id="disclaimer"
                                                          v-model="dynamicFields.disclaimer"
                                                          @change="updateDisclaimer()"
                                                          class="form-control template-checkbox pt-0"
                                                          v-validate.continues="`${checkAndValidate1('disclaimer')}`"></md-checkbox>
                                            <label v-html="configureFields.disclaimer.labelName" class="html-disclaimer" for="disclaimer"></label>
                                            <p  v-show="errors.has('form-request.disclaimer')"
                                                class="error error-mt-2 template-checkbox-error" >{{ errors.first('form-request.disclaimer') }}</p>
                                        </div>
                                    </div>
                                    <div class="template-mb-30" v-if="configureFields.disclaimer && configureFields.disclaimer.include === false"></div>
                                    <!-- <div id="tips">
                                      Not sure how to ask? Read our
                                      <a  :href="community.content.tips" target="_blank" v-if="community.content && community.content.tips && community.content.tips.length">tips</a>
                                      <span v-else>tips</span>.
                                    </div> -->
                                      <div class="btn-block text-right mlr0 text-center-xs ">
                                        <md-button v-bind:style="reviewBtn" type="submit"
                                                  name="unsubscribe"
                                                  class="btn btn_info template-review-submit template-button template-button-width">Next
                                                  </md-button>
                                      </div>
                                </form>
                            </template>
                            <div v-show="!isBeforRequest && !isSubmitForm"  class="form-template">
                              <h2 class="template-title common-space-from-logo">Ready for your close-up?</h2>
									                <p class="custom-content" v-if="community.content && community.content.formConfirmation" v-html="community.content.formConfirmation"></p>
                                  <hr class="template-hr-custom" />
                                  <div class="about-feedbackreq">
                                    <div class="template-request-review">
                                      <h2 aria-level="2" role="Presentation" v-if="ask.first && ask.last">{{ ask.first + ' ' + ask.last }}</h2>
                                      <tr>
                                        <td  role="Presentation" class="fs_15 lh_111" style="font-family:'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif; text-align:left; font-size:18px; color:#777479; mso-line-height-rule:exactly; line-height:20px;">
                                          <span v-if="dynamicFields.college || school">{{dynamicFields.college|| school }}</span> 
                                          <span v-if="dynamicFields.year || year"> ({{dynamicFields.year || year }})</span>
                                        </td>
                                    </tr>
                                    <br>
                                      <h2 aria-level="2" role="Presentation">{{ ask.subject }}</h2>
                                      <p class="font-color">{{ ask.text }}</p>
                                    </div>

                                    <div class="row back-next-step-2 pl-25 pr-25">
                                        <div class="text-center-xs float-left">
                                          <a
                                            href="javaScript:void(0)"
                                            :style="styleEditBtn"
                                            @click="isBeforRequest = true"
                                            class="btn btn_info template-review-edit template-button template-button-width mb-10"
                                            tabindex="0"
                                            role="button"
                                            >Back</a>
                                        </div>
                                        <div class="text-center-xs float-right">
                                          <md-button
                                            tabindex="0"
                                            :disabled="disabledBtn == 1 ? true : false"
                                            :style="styleSubmitBtn"
                                            @click="sendCreate()"
                                            class="btn btn_info template-review-submit template-button template-button-width"
                                            >Submit
                                         </md-button>
                                        </div>
                                    </div>
                                  </div>
                            </div>
                            <template v-if="this.isSubmitForm && !this.unsubscribe && !this.spamEmail && !this.invalidMember">
                                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation'>
                                  <h2 class="box-heading thankyou-template-title" role="alert" aria-live="Assertive">
                                        So what's next?
                                    </h2>
                                  <div v-if="community.content && community.content.requestPageThankYou" class="box-sub-heading text-left content-textleft thankyou-custom-content" v-html="community.content.requestPageThankYou"></div>
                                    <div  v-else class="box-sub-heading text-left content-textleft thankyou-custom-content">We will now recruit the right experts to help you.</div>
                                </div>
                            </template>
                            <template v-if="this.unsubscribe && this.isSubmitForm">
                                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg'>
                                    <div class="box-sub-heading thankyou-custom-content content-textleft text-warning">Your email address has been unsubscribed.</div>
                                </div>
                            </template>
                            <template v-if="this.spamEmail && this.isSubmitForm">
                                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg'>
                                    <div class="box-sub-heading thankyou-custom-content content-textleft spam-email">Your email address has been blocked.</div>
                                </div>

                            </template>
                            <template v-if="this.invalidMember && this.isSubmitForm">
                                <div class='header-text common-space-from-logo text-left'>
                                    <h2 class="box-heading thankyou-template-title">Ooops. We’re really sorry. </h2>
                                    <div class="box-sub-heading text-left content-textleft thankyou-custom-content" v-html="finalInvalidMemberMessage"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" >Learn More</a>
                            <a  href="javascript:void(0)" v-else >Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" >Terms Of Use</a>
                            <a  href="javascript:void(0)" v-else >Terms Of Use</a>
                        </li>
                        <li>
                            <a  :href="community.content.unsubscribePageURL" target="_blank" class="links" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length" >Opt Out</a>
                            <a  href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                    </ul>
                    <div class="unsubscribe-community-logo">
                        <a href="https://www.protopia.co" target="_blank"><img :src="footerLogoURL" alt='Community Logo'></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<!-- Script -->

<script>
import API from "../services/API";
import Member from "./Member";
import Datepicker from 'vuejs-datepicker';
import CustomSkeleton from './CustomSkeleton.vue';
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";

export default {
  components: {
    Member,
    Datepicker,
    CustomSkeleton
  },
  props: ["community_id", "sourceparam"],
  data() {
    return {
      api: new API(),
      ask: {},
      community: {},
      fullPage: true,
      max: 2000,
      remainingCount: 0,
      message: "",
      isBeforRequest: true,
      exceedsMaxCount: false,
      configureFields: {
        firstName: {
          labelName: ''
        },
        lastName: {
          labelName: ''
        },
        emailAddress: {
          labelName: ''
        },
        subject: {
          labelName: ''
        },
        question: {
          labelName: ''
        },
        referrer: {
          labelName: ''
        },
        referrer2: {
          labelName: ''
        }
      },
      dynamicFields: {},
      school: '',
      year: '',
      newAdmin: [],
      requestForm: {
        subjectLine: 'Short summary ...',
        question: "I have a question about ..."
      },
      isSubmitForm: false,
      reviewBtn: {
          background: '#9178A0',
          color: '#ffffff'
      },
      submitBtn: {
        colorBackd: '#9178A0',
        color: '#ffffff'
      },
     editBtn: {
         colorBackd: '#CBA8E0',
         color: '#ffffff'
     },
     unsubscribe: false,
     spamEmail: false,
     memberThankYou: "",
     DatePickerFormat: "MM/dd/yyyy",
     disabledDates: {
       to: new Date(Date.now() - 8640000)
     },
     logoURL: '',
     referrer2: {},
     footerLogoURL: "",
     askId: '',
     memberRole: {},
     adviceArea: {},
     channelType: "Request Form Long",
      invalidMember: false,
      finalInvalidMemberMessage: "",
      disabledBtn: 0,
      isShow: 0,
      autoFocus: false
    };
  },
  watch: {
    $route: "loadData"
  },
  computed: {
    styleSubmitBtn() {
      return {
        'color': this.submitBtn.color,
        'background-color': this.submitBtn.colorBackd
      };
    },
    styleEditBtn() {
      return {
        'border-color': this.editBtn.colorBackd
        //'--editBtn-color': this.editBtn.color,
       //'--editBtn-background-color': this.editBtn.colorBackd
      };
    }

  },
  // mounted() {
  //   this.$refs['firstName'].focus()
  // },
  created: async function() {
    // setTimeout(() => {
    //   this.$refs.firstName.focus();
    // }, 1000);
    var date = new Date();
    var AddDay = date.setDate(date.getDate() + 1);
    this.disabledDates.to = new Date(AddDay - 8640000);
    this.loadData();
    if (this.$route.query && this.$route.query.askid) {
        this.isBeforRequest = false
        this.askId = this.$route.query.askid;
        await this.api.get(`asks/${this.askId}/getone`).then(ask => {
            if (ask.data) {
                this.ask = {
                    first: ask.data.createdByMemberID.first,
                    last: ask.data.createdByMemberID.last,
                    email: ask.data.createdByMemberID.emails[0],
                    subject: ask.data.subject,
                    text: ask.data.text
                }
                this.dynamicFields = {
                    linkedInProfile: ask.data.createdByMemberID.linkedIn ? ask.data.createdByMemberID.linkedIn : '',
                    college: ask.data.createdByMemberID.school1 ? ask.data.createdByMemberID.school1 : '',
                    year: ask.data.createdByMemberID.year1 ? ask.data.createdByMemberID.year1 : '',
                    role: ask.data.createdByMemberID.roles.length ? ask.data.createdByMemberID.roles[0] : '',
                    organization: ask.data.createdByMemberID.organization ? ask.data.createdByMemberID.organization : '',
                    studentId: ask.data.createdByMemberID.studentId ? ask.data.createdByMemberID.studentId : '',
                    dueDate: ask.data.dueDate ? ask.data.dueDate : ''
                }
            }
        });
    }
    const dict = {
      custom: {
        email: {
          required: () => "Please enter your email address",
          email: () => "Please enter a valid email address"
        },
        first: {
          required: () => "Please enter your first name"
        },
        last: {
          required: () => "Please enter your last name"
        },
        title: {
          required: () => "Please enter a subject line"
        },
        message: {
          required: () => "Please enter a question",
          max: () => "Message may not exceed 500 characters"
        },
        college: {
          required: () => "Please enter your college"
        },
        year: {
          required: () => "Please enter your class year"
        },
        role: {
          required: () => "Please enter a title"
        },
        organization: {
          required: () => "Please enter an organization"
        },
        studentId: {
          required: () => "Please enter " + this.configureFields.studentId.labelName.toLowerCase()
        },
        dueDate: {
          required: () => "Please enter valid date"
        },
        linkedInProfile: {
          required: () => "Please enter linkedin profile url",
          regex: () => "Please enter valid url"
        },
        phoneNumber: {
          required: () => "Please enter phone number"
        },
        referrer: {
          required: () => `Please enter about ${this.community.name} community`
        },
        referrer2: {
          required: () => `Please select about ${this.community.name} community`
        },
        disclaimer: {
          required: () => "Please check the above box."
        },
        memberRole: {
          required: () => "Please select value."
        },
        adviceArea: {
          required: () => "Please select value."
        }
      }
    };
    // or use the instance method
    this.$validator.localize("en", dict);
  },
  methods: {
    countdown: function() {
      this.remainingCount = this.max - this.ask.text.length;
      this.remainingCount === 0
        ? (this.exceedsMaxCount = true)
        : (this.exceedsMaxCount = false);
    },
    loadData: async function() {
      this.memberThankYou = '';
      try {
              const startTime = Date.now();
              let fetchDataPromise = Promise.all([
              await this.api.get(`communities/${this.community_id}/community-request`).then(community => {
                this.community = community.data;
                document.title = this.community.name + " | Get Help";
                const customSettings = this.community.customSettings;
                this.channelType = this.community.friendlyNames.requestForm2;
                if (this.community.content.requestPageThankYou) {
                    let replaceStr = this.community.content.requestPageThankYou.replace(/\n/g, "<br />");
                    if (replaceStr.indexOf('ask.sourceparam') != -1) {
                      let re = new RegExp(`\\{\\{\\s?ask.sourceparam\\s?\\}\\}`, 'gi');
                      replaceStr = replaceStr.replace(re, this.sourceparam);
                    }
                    this.community.content.requestPageThankYou = replaceStr;
                }
                if (this.community.content.memberThankYou) {
                    this.memberThankYou = this.community.content.memberThankYou;
                }
                if (this.community.content.requestForm) {
                  this.requestForm.subjectLine = this.community.content.requestForm.subjectLine.trim() == '' ? 'Short summary ...' : this.community.content.requestForm.subjectLine.trim();
                  this.requestForm.question = this.community.content.requestForm.question.trim() == '' ? "I have a question about ..." : this.community.content.requestForm.question.trim();
                }
                if (this.community.content.configureFields && this.community.content.configureFields.memberRole) {
                    this.memberRole = this.community.content.configureFields.memberRole;
                    if (this.memberRole.value) {
                        this.dynamicFields.memberRole = '';
                        this.memberRole.memberValue = this.memberRole.value.split(",");
                    }
                }
                if (this.community.content.configureFields && this.community.content.configureFields.adviceArea) {
                    this.adviceArea = this.community.content.configureFields.adviceArea;
                    if (this.adviceArea.value) {
                        this.dynamicFields.adviceArea = '';
                        this.adviceArea.memberValue = this.adviceArea.value.split(",");
                    }
                }
                this.submitBtn.colorBackd = customSettings.primaryBtnBgColor;
                this.submitBtn.color = customSettings.primaryTxtColor;
                this.editBtn.colorBackd = customSettings.secondaryBtnBgColor;
                this.editBtn.color = customSettings.secondaryTxtColor;
                this.reviewBtn = {
                    background: customSettings.primaryBtnBgColor,
                    color: customSettings.primaryTxtColor
                };

                // customSettings.primaryBtnBgColor
                if (community.data.content && community.data.content.configureFields) {
                    this.configureFields = community.data.content.configureFields;
                }
                if (this.community.content.configureFields && this.community.content.configureFields.referrer && this.community.content.configureFields.referrer.labelName) {
                  this.configureFields.referrer.labelName = this.configureFields.referrer.labelName.replace('{{community.name}}', community.data.name);
                }
                if (this.community.content.configureFields && this.community.content.configureFields.referrer2 && this.community.content.configureFields.referrer2.labelName) {
                  this.configureFields.referrer2.labelName = this.configureFields.referrer2.labelName.replace('{{community.name}}', community.data.name);
                  this.referrer2 = this.community.content.configureFields.referrer2;
                  if (this.referrer2.value) {
                    this.dynamicFields.referrer2 = '';
                    this.referrer2.memberValue = this.referrer2.value.split(",");
                  }
                }
                this.logoURL = getLogoURL(customSettings);
                this.footerLogoURL = getFooterURL(customSettings);
                let re = new RegExp(`\\{\\{\\s?community.email\\s?\\}\\}`, 'gi');
                this.finalInvalidMemberMessage = this.community.content.invalidMemberMessage.replace(re, (this.community.sender && this.community.sender.address) ? this.community.sender.address : process.env.DEFAULT_EMAIL);
              })

            ]);
            await this.$helpers.redirectWhenResponseIsSlow(fetchDataPromise, startTime);
            this.isShow = 1;
            this.scrollAfterSkeleton();
          } catch (error) {
              if (error.message === 'Timeout occurred') {
                    window.open(process.env.APP_REDIRECT_URL, '_self');
                } else {
                    console.log("Error while fetching the data", error);
                }
            }

      this.$validator.errors.clear();
      this.$validator.reset();
      setTimeout(() => {
        this.addEventListenersToFormFields();
      }, 1000);
    },
    scrollAfterSkeleton: async function() {
        const duration = 500;
        const start = window.scrollY;
        const startTime = performance.now();
        const easeInOutQuad = (t, b, c, d) => {
          t /= d / 2;
          if (t < 1) return c / 2 * t * t + b;
          t--;
          return -c / 2 * (t * (t - 2) - 1) + b;
        };
        const animateScroll = (timestamp) => {
          const currentTime = timestamp - startTime;
          window.scrollTo(0, easeInOutQuad(currentTime, start, -start, duration));
          if (currentTime < duration) {
            requestAnimationFrame(animateScroll);
          } else {
            window.scrollTo(0, 0);
          }
        };
        requestAnimationFrame(animateScroll);
    },
    save: function(scope) {
      if (this.community.settings.siteStatus == "Inactive") {
        this.$toast.error('We are no longer accept requests.');
        return null;
      }
      this.autoFocus = true
      this.$validator.validateAll(scope).then(result => {
        if (result) {
            window.scrollTo(0, 0);
            this.isBeforRequest = false;
        } else {
            this.handleErrorMessages();
        }

      });
    },
    async sendCreate() {
      if (typeof this.ask.subject == 'undefined' || this.ask.subject === '') {
        this.$toast.error(`Please enter valid subject for the request.`);
        return false;
      }
      await this.api
      .get(`communities/${this.community_id}/administrators`)
      .then(administrators => {
          this.administrators = administrators.data;
          if (administrators && administrators.data) {
            this.administrators.map(singleAdmin => {
              this.newAdmin.push(singleAdmin.member);
            })
          }
      })
      this.disabledBtn = 1;
      this.ask.community = this.community._id;
      this.ask.recipients = this.newAdmin;
      this.ask.dynamicFields = this.dynamicFields;
      this.ask.channelType = this.channelType;
      this.ask.sourceparam = this.sourceparam;
      this.ask.source = {
        origin: "request page",
        sourceID: `timestamp:${Date.now()}`,
        userID: "Web user"
      };
        if (!this.unsubscribe && !this.spamEmail && !this.invalidMember) {
            this.deleteTempRequest();
            if (this.askId) {
                this.api.post(`asks/${this.askId}/close-request`)
                .then(closeAsk => { });
            }
            document.title = this.community.name + " | Thank You";
            if (this.memberThankYou) {
                window.open(this.memberThankYou, '_self');
            } else {
                window.scrollTo(0, 0);
                this.isBeforRequest = false;
                this.isSubmitForm = true;
            }
            await this.api.post(`communities/${this.community_id}/create-ask/`, this.ask)
            .then(async ask => {
                if (this.memberThankYou && !ask.data.unsubscribe && !ask.data.spamEmail && !ask.data.invalidMember && !ask.data.inactiveMember) {
                    this.callTrackEvent(ask);
                    window.open(this.memberThankYou, '_self');
                } else {
                    // if (ask.data.unsubscribe) {
                    //     this.unsubscribe = true;
                    // }
                    // if (ask.data.spamEmail) {
                    //     this.spamEmail = true;
                    // }
                    // if (ask.data.invalidMember || ask.data.inactiveMember) {
                    //     this.invalidMember = true;
                    //     this.tempRequestStore();
                    // }
                    if (!this.spamEmail && !this.unsubscribe && !this.invalidMember) {
                      document.title = this.community.name + " | Thank You";
                    }
                    //this.isBeforRequest = false;
                    this.callTrackEvent(ask);
                    //this.isSubmitForm = true;
                }
                //window.scrollTo(0, 0);
            });
        } else {
            this.isBeforRequest = false;
            this.isSubmitForm = true;
            if (this.invalidMember) {
                this.tempRequestStore();
            }
            window.scrollTo(0, 0);
        }
    },
    tempRequestStore: async function() {
        this.ask.community = this.community._id;
        this.ask.dynamicFields = this.dynamicFields;
        this.ask.channelType = this.channelType;
        this.ask.sourceparam = this.sourceparam;
        this.ask.reason = true;
        await this.api.post(`asks/${this.community_id}/create-temp-request/`, this.ask).then(response => {});
    },
    deleteTempRequest: async function() {
        this.api.post(`asks/${this.community_id}/delete-temp-request/`, this.ask).then(response => {});
    },
    callTrackEvent(ask) {
        this.$gtm.enable(true)
        this.$gtm.trackEvent({
            'RequestID': ask.data._id,
            'RequestSource': 'Web',
            'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
            'Community': this.community.name,
            'event': 'RequestSubmitted'
        });
    },
    checkAndValidate1(field) {
      var validationRules;
      if (this.configureFields && field === 'college') {
         validationRules = this.configureFields.college && this.configureFields.college.require && this.configureFields.college.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'year') {
         validationRules = this.configureFields.classYear && this.configureFields.classYear.require && this.configureFields.classYear.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'role') {
        validationRules = this.configureFields.title && this.configureFields.title.require && this.configureFields.title.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'organization') {
        validationRules = this.configureFields.organization && this.configureFields.organization.require && this.configureFields.organization.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'studentId') {
        validationRules = this.configureFields.studentId && this.configureFields.studentId.require && this.configureFields.studentId.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'dueDate') {
        validationRules = this.configureFields.dueDate && this.configureFields.dueDate.require && this.configureFields.dueDate.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'linkedInProfile') {
        validationRules = this.configureFields.linkedInProfile && this.configureFields.linkedInProfile.require && this.configureFields.linkedInProfile.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'phoneNumber') {
        validationRules = this.configureFields.phoneNumber && this.configureFields.phoneNumber.require && this.configureFields.phoneNumber.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'referrer') {
        validationRules = this.configureFields.referrer && this.configureFields.referrer.require && this.configureFields.referrer.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'referrer2') {
        validationRules = this.configureFields.referrer2 && this.configureFields.referrer2.require && this.configureFields.referrer2.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'disclaimer') {
        validationRules = this.configureFields.disclaimer && this.configureFields.disclaimer.require && this.configureFields.disclaimer.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'memberRole') {
        validationRules = this.configureFields.memberRole && this.configureFields.memberRole.require && this.configureFields.memberRole.require === true ? 'required' : '';
        return validationRules;
      } else if (this.configureFields && field === 'adviceArea') {
        validationRules = this.configureFields.adviceArea && this.configureFields.adviceArea.require && this.configureFields.adviceArea.require === true ? 'required' : '';
        return validationRules;
      }
    },
    updateDisclaimer: function() {
        if (this.dynamicFields.disclaimer === false && this.configureFields.disclaimer.require && this.configureFields.disclaimer.require === true) {
            this.dynamicFields.disclaimer = undefined;
        }
    },
    checkMemberStatus: function() {
        this.api.post(`communities/${this.community_id}/get-member-details/`, this.ask)
            .then(async ask => {
                this.unsubscribe = this.spamEmail = this.invalidMember = false;
                if (ask.data.unsubscribe) {
                    this.unsubscribe = true;
                }
                if (ask.data.spamEmail) {
                    this.spamEmail = true;
                }
                if (ask.data.invalidMember || ask.data.inactiveMember) {
                    this.invalidMember = true;
                }
                if(ask.data.school1){
                  this.school = ask.data.school1;
                }
                if(ask.data.year1){
                  this.year = ask.data.year1;
                }
            })
    },
    handleErrorMessages: function() {
          const errorElements = document.querySelectorAll('.error');
              if (errorElements.length > 0) {
                  let isFirstErrorFocused = false;
                  for (let errorElement of errorElements) {
                        if (errorElement.style.display !== 'none') {
                          let inputElement = '';
                            inputElement = errorElement.previousElementSibling;
                            while (inputElement) {
                                if ((inputElement.tagName === 'INPUT' || inputElement.tagName === 'SELECT' || inputElement.tagName === 'DIV' || inputElement.tagName === 'TEXTAREA') && !isFirstErrorFocused) {
                                    if (inputElement.tagName === 'DIV' || inputElement.tagName === 'TEXTAREA') {
                                        if (inputElement.parentNode.querySelector('textarea.request-form-error-border')) {
                                          inputElement.parentNode.querySelector('textarea.request-form-error-border').focus();
                                          let message = '';
                                          if (inputElement.tagName === 'TEXTAREA'){
                                            message = errorElement.querySelector('span').innerText;
                                          } else {
                                            message = errorElement.innerText;
                                          }
                                          this.errorMessageAnnouncement(message);
                                            isFirstErrorFocused = true;
                                            break;
                                        }
                                    } else {
                                      inputElement.focus();
                                      this.errorMessageAnnouncement(errorElement.innerText);
                                      setTimeout(() => {
                                        this.autoFocus = false;
                                      }, 2000);
                                      isFirstErrorFocused = true;
                                        break;
                                    }
                                }
                                inputElement = inputElement.previousElementSibling;
                            }
                        }
                    }
                }
    },
    errorMessageAnnouncement(message) {
      const liveRegion = document.createElement('div');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('role', 'alert');
      liveRegion.innerText = message;
      document.body.appendChild(liveRegion);
      setTimeout(() => {
        liveRegion.remove();
      },1000);
    },
    addEventListenersToFormFields: function() {
      const form = document.querySelectorAll('input, textarea, select');
      form.forEach((element) => {
        element.addEventListener('focus', (event) => {
          if (!this.autoFocus) {
            var formField = event.target;
            var message = '';
            if (formField.tagName === 'INPUT' || formField.tagName === 'SELECT') {
              message = formField.nextElementSibling.innerText;
            } else if (formField.tagName === 'TEXTAREA') {
              let errorField = document.getElementById('question-field-error').firstChild;
              if (errorField) {
                message = errorField.innerText;
              }
            }
            this.errorMessageAnnouncement(message);
          }
        });
      });
    }
  }
};
</script>

<style>
.unsubscribe-pagecard .feedback_newupdate .about-feedbackreq .btn-feedbackupdatenew.active {
  color: var(color);
  background-color: var(background-color);
}
.unsubscribe-pagecard .feedback_newupdate .about-feedbackreq .btn-feedbackupdatenew {
  color: var(--editBtn-color);
  background-color: var(--editBtn-background-color);
}
</style>



// WEBPACK FOOTER //
// src/components/CommunityRequestPageV2.vue